import { validate } from '../../utils/validate';

export const handleFormSubmit = ({
  currentUsername,
  dispatchGoldMigrationLogin,
  dispatchGoldMigrationLoginError,
  dispatchResetFormErrors,
  formValues,
  isPasswordRequired,
  isUsernameRequired,
  operation,
  usernameForLogin,
}) => {
  dispatchResetFormErrors();
  const errorsArray = [];

  if (isUsernameRequired) {
    const usernameError = validate({
      required: true,
      type: 'username',
      value: formValues.username,
    });
    if (usernameError) {
      errorsArray.push({ key: 'username', ...usernameError });
    }
  }
  if (isPasswordRequired) {
    const passwordError = validate({
      required: true,
      type: 'password',
      value: formValues.password,
    });
    if (passwordError) {
      errorsArray.push({ key: 'password', ...passwordError });
    }

    const confirmPasswordError = validate({
      comparisonValue: formValues.password,
      name: 'Password',
      required: true,
      type: 'concurrentFields',
      value: formValues.confirmPassword,
    });
    if (confirmPasswordError) {
      errorsArray.push({ key: 'confirmPassword', ...confirmPasswordError });
    }
  }

  const isAllValid = !errorsArray.length;
  if (isAllValid) {
    dispatchGoldMigrationLogin({
      operation,
      password: formValues.password,
      username: isUsernameRequired ? formValues.username : currentUsername,
      usernameForLogin,
    });
  } else {
    dispatchGoldMigrationLoginError({ formErrors: errorsArray });
  }
};
